// Production-safe logging helper.
//
// In development (`process.env.NODE_ENV !== "production"`) calls pass
// straight through to `console.*` so we still get the warnings while
// debugging. In production they're no-ops so we don't leak internal
// errors to the browser DevTools of public visitors.
//
// Usage:
//   import { log } from "../lib/log";
//   log.warn("something happened", err);

const isProd = process.env.NODE_ENV === "production";

const noop = () => {};

export const log = {
  debug: isProd ? noop : (...a) => console.debug(...a),  // eslint-disable-line no-console
  info: isProd ? noop : (...a) => console.info(...a),    // eslint-disable-line no-console
  warn: isProd ? noop : (...a) => console.warn(...a),    // eslint-disable-line no-console
  error: isProd ? noop : (...a) => console.error(...a),  // eslint-disable-line no-console
};
